import { Services } from "./Services";
import BaseClient from "./BaseClient";

const baseURL = Services.TRACEABILITY.path;

// const baseURL = "http://localhost:4637";

const ShipmentClient = new BaseClient(baseURL);

export default ShipmentClient;
